import{c as e}from"./chunk-VMPAE4NV.js";import{a as o}from"./chunk-BBBZEERM.js";import{m as t}from"./chunk-HBP5N4FR.js";t();function f(){return e(o.getState())}export{f as a};
//# sourceMappingURL=chunk-G65FNHLP.js.map
